import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';


const LazyContractors = lazy(() => import('./Contractors'));

export const Contractors: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazyContractors {...props} />
	</Suspense>
);
